<script setup lang="ts">
import { GDialog } from 'gitart-vue-dialog';
import { computed } from 'vue';
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue']);

const props = defineProps<{
  modelValue: boolean
  messages: string[]
  moveDailyReportDisplay: () => void
}>();

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

function closeModal() {
  modelValue.value = false;
  props.moveDailyReportDisplay();
}
</script>
<template>
  <GDialog
    v-model="modelValue"
    max-width="30%"
    transition="custom-from-bottom-transition"
    :persistent='true'
  >
    <div class="modal-header justify-content-center pt-3">
      <label>
        {{ i18n.global.t('pages.dailyReports.splitCompleteModal.title') }}
      </label>
    </div>
    <div class="row mt-2 mr-3 ml-12 pl-5 v-theme--light">
      {{ props.messages[0] }}
      <br />
      {{ props.messages[1] }}
    </div>
    <div class="d-flex justify-content-end m-3">
      <v-btn
        class="m-1 reset-btn"
        @click="closeModal"
      >
        {{ i18n.global.t('pages.common.button.close') }}
      </v-btn>
    </div>
  </GDialog>
</template>
